// ----------------------------------------------------------------------
// <copyright file="Izenda.VirtualList.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var React = require('react');
  var PropTypes = React.PropTypes;
  var ObservablePropTypes = require('mobx-react').propTypes;
  var Utils = require('share/utils/Izenda.DomUtils');
  var VirtualListItem = require('./Izenda.VirtualListItem');
  var VirtualListUIStore = require('./Izenda.VirtualListUIStore');
  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');

  var resizeDetector = require('share/utils/Izenda.SizeDetector');
  var observer = require('mobx-react').observer;

  var DEFAULT_SCROLL_THROTTLE = 150;
  var DEFAULT_PAGE_TO_SCREEN_RATIO = 3;
  const { invokeArgs, debounce } = require('lodash/fp');
  var VirtualHeight = observer(function(props) {
    var virtualHeight = props.virtualStore.virtualHeight;

    return (
      <div className={props.className} ref={props.childRef} style={{ height: virtualHeight }}>
        {props.children}
      </div>
    );
  });

  var BufferHeight = observer(function(props) {
    var bufferHeight = props.virtualStore.bufferHeight;

    return <div style={{ height: bufferHeight }} className={props.className} />;
  });

  var VirtualList = React.createClass({
    virtualStore: null,
    propTypes: {
      dataSource: ObservablePropTypes.arrayOrObservableArray.isRequired,
      renderItem: PropTypes.func.isRequired,
      getChildItems: PropTypes.func,
      getItemKey: PropTypes.func,
      pageToScreenRatio: PropTypes.number,
      // Throttle milisecond of scrolling event
      scrollThrottle: PropTypes.number,
      // Indicate the virtual list has its own scroll bars
      ownScroll: PropTypes.bool
    },
    getDefaultProps: function() {
      return {
        pageToScreenRatio: DEFAULT_PAGE_TO_SCREEN_RATIO,
        scrollThrottle: DEFAULT_SCROLL_THROTTLE,
        ownScroll: false
      };
    },
    componentWillMount: function() {
      var props = this.props;
      var pageToScreenRatio = props.pageToScreenRatio;
      var dataSource = props.dataSource;
      this.virtualStore = new VirtualListUIStore(pageToScreenRatio, dataSource);
      invokeArgs('registerVirtualStore', [this.virtualStore], props);
    },
    componentWillReceiveProps: function(nextProps) {
      var dataSource = nextProps.dataSource;
      var getChildItems = this.props.getChildItems;

      this.virtualStore.initialize(dataSource, getChildItems);
    },
    componentDidMount: function() {
      var dataSource = this.props.dataSource;
      var getChildItems = this.props.getChildItems;
      this.virtualStore.initialize(dataSource, getChildItems);
      this.listen();
    },
    componentWillUnmount: function() {
      this.unlisten && this.unlisten();
      this.virtualStore.release();
      this.virtualStore = null;
      this.unlisten = null;
    },
    render: function() {
      var props = this.props;
      var ownScroll = props.ownScroll;

      return ownScroll ? (
        <VirtualHeight className={props.className} childRef={this.setViewDom} virtualStore={this.virtualStore}>
          <ScrollBox onScroll={this.onScroll}>
            <BufferHeight virtualStore={this.virtualStore} className={props.bufferClassName} />
            {this.renderList()}
          </ScrollBox>
        </VirtualHeight>
      ) : (
        <VirtualHeight className={props.className} childRef={this.setViewDom} virtualStore={this.virtualStore}>
          <BufferHeight virtualStore={this.virtualStore} className={props.bufferClassName} />
          {this.renderList()}
        </VirtualHeight>
      );
    },
    renderList: function() {
      var itemIndex, itemsLength;
      var virtualStore = this.virtualStore;
      var virtualListItems = [];
      var virtualItemsOnScreen = virtualStore.virtualItemsOnScreen;
      for (itemIndex = 0, itemsLength = virtualItemsOnScreen.length; itemIndex < itemsLength; itemIndex++) {
        virtualListItems.push(this.renderItem(virtualItemsOnScreen[itemIndex]));
      }

      return virtualListItems;
    },
    renderItem: function(virtualItem) {
      var renderItem = this.props.renderItem;
      var getItemKey = this.props.getItemKey;
      var dataItem = virtualItem.dataItem;
      var item = renderItem(dataItem, virtualItem.itemIndex);
      var key = getItemKey(dataItem) || virtualItem.itemIndex;

      return (
        item && (
          <VirtualListItem item={virtualItem} key={key}>
            {item}
          </VirtualListItem>
        )
      );
    },
    setViewDom: function(dom) {
      this.viewDom = dom;
    },
    getView: function() {
      return this.viewDom;
    },
    getBuffer: function() {
      return this.refs.buffer;
    },
    listen: function() {
      var virtual = this;
      var ownScroll = this.props.ownScroll;
      var scrollThrottle = this.props.scrollThrottle;
      var view = this.getView();
      var scrollParent = Utils.findScrollableParent(view);
      if (scrollParent) {
        var viewport = scrollParent.parentNode;

        this.virtualStore.setViewportDimension(viewport.clientWidth, viewport.clientHeight);
        // Listen to virtual view resizing
        var throttleResize = debounce(scrollThrottle, function(elm) {
          virtual.onResize(elm);
        });
        resizeDetector.listenTo(viewport, throttleResize);

        if (!ownScroll) {
          this.onScroll(scrollParent);
          this.throttleScroll = debounce(scrollThrottle, scrollEvent => this.onScroll(scrollEvent.target), {
            maxWait: scrollThrottle * 3
          });
          scrollParent.addEventListener('scroll', this.throttleScroll, {
            capture: false,
            passive: true
          });
        }

        this.unlisten = function() {
          resizeDetector.removeListener(viewport, throttleResize);

          if (!ownScroll) {
            scrollParent.removeEventListener('scroll', this.throttleScroll, {
              capture: false,
              passive: true
            });
          }
        };
      }
    },
    onResize: function(elm) {
      var width = elm.clientWidth;
      var height = elm.clientHeight;
      if (this.isMounted()) {
        this.virtualStore.setViewportDimension(width, height);
      }
    },
    onScroll: function(viewNode) {
      var position = viewNode.scrollTop;
      var view = this.getView();

      if (!this.props.ownScroll) {
        var relativePosition = Utils.findRelativePositionToAcesstor(view, viewNode);
        position = -relativePosition.top;
      }

      this.virtualStore && this.virtualStore.calculateStartIndex(position);
    }
  });
  module.exports = observer(VirtualList);
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.VirtualList.jsx